import React, { useState } from 'react'
import { Popover as AntdPopover,} from "antd";
import { Row, Col, Tabs, Tab,} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TimePicker from "react-time-picker/dist/entry.nostyle";
import { UncontrolledCollapse, UncontrolledTooltip } from 'reactstrap';
import {faBell, faChevronCircleDown, faExclamationTriangle, faEye, 
  faMinus, faPauseCircle, faPlayCircle, faSlidersH, faStopCircle, faStopwatch,
  faTags, faTrashAlt,} from "@fortawesome/free-solid-svg-icons";
import TaskGlobalSearch from '../common/TaskGlobalSearch/TaskGlobalSearch';
import { convert24to12, getGroupVal} from '../common/util/appUtils';
import TopPositionTimeTrack from './TopPositionTimeTrack';
import TaskService from '../common/util/TaskService';
import moment from 'moment';
import swal from "sweetalert";

export default function TimeTrackingWrapper({timeTrackClock, timerObj, timerTimeTrack, 
    timerPrevTimeTrack, setTimerTimeTrack, setTimerPrevTimeTrack, startstopClockTimeTrack, 
    timeTrackLogs, setDeleteTimeLogObj, setTimeDeleteWarn, setTimerObj, handleOnOpenTask, 
    allJobs, cacheDeals,getAllTimeTrackLogs}) {
  
   const [timeTrackKey, setTimeTrackKey] = useState("timer");
   const [FromRange, setFromRange] = useState(null);
   const [ToRange, setToRange] = useState(null);
   const [timeLogDate, setTimeLogDate] = useState(null);

const onSaveTimeRange = (start, stop, date) => {
        if (!start || !stop || !date) {
          swal("Please select date and time", { dangerMode: true });
          return;
        }
        if (!timerObj || !timerObj.jobId) {
          swal("Please select task", { dangerMode: true });
          return;
        } 
        start = start.split(":");
        stop = stop.split(":");
        let from = new Date(Date.now());
        from.setHours(parseInt(start[0]));
        from.setMinutes(parseInt(start[1]));
        let till = new Date(Date.now());
        till.setHours(parseInt(stop[0]));
        till.setMinutes(parseInt(stop[1]));
        start = convert24to12(from);
        stop = convert24to12(till);
        date = moment(new Date(date)).format("YYYY-MM-DD");
        TaskService.addTimeTrack(
          timerObj.jobId,
          timerObj.jobName,
          date,
          "david@srsolardesign.com",
          start,
          stop
        ).then((result) => {
            if (result.errors) {
              alert(result.errors.message);
            } else {
              alert(result.message);
              setTimeLogDate(null);
              setFromRange(null);
              setToRange(null);
              setTimerObj({});
            }
            return getAllTimeTrackLogs("all");
          })
          .catch((err) => {
            console.error(err);
            alert(err);
          });
      };

  const getTaskToolTipLabel = (obj) => {
      if (obj) {
        let jobs = [...allJobs];
        let alldeals = [...cacheDeals];
        jobs = jobs.filter((job) => job.jobId == obj.jobId);
        if (jobs.length > 0) {
          jobs = jobs[0];
          alldeals = alldeals.filter((one1) => {
            let ids = one1.Project_ID;
            if (ids) {
              ids = ids.split(",");
              ids = ids.filter((id) => id);
              if (ids.includes(jobs.zProjectsProjectRefId)) {
                return one1;
              }
            }
          });
  
          if (alldeals.length > 0) {
            alldeals = alldeals[0];
            if (alldeals.Account_Name) {
              return (
                <div>
                  Accounts:<p>{alldeals.Account_Name.name}</p>
                  Deal:<p>{alldeals.Deal_Name}</p>
                  Pipeline:<p>{getGroupVal(obj.projectName)}</p>
                  Task:<p>{obj.jobName}</p>
                </div>
              );
            } else {
              return (
                <div>
                  Accounts:<p>N/A</p>
                  Deal:<p>{alldeals.Deal_Name}</p>
                  Pipeline:<p>{getGroupVal(obj.projectName)}</p>
                  Task:<p>{obj.jobName}</p>
                </div>
              );
            }
          }
        }
      } else {
        return <>ghjgfjgfj</>;
      } 
    }; 
  return (<div>
    <UncontrolledTooltip placement="top" target="time-track-icon">
                          Time Track{" "}
                          {timeTrackClock && timerObj ? "/" + timerObj.jobName : ""}
                        </UncontrolledTooltip>
                        <AntdPopover
                          trigger={"click"}
                          content={
                            <div className="common-time-tracker">
                              <div id="timetracklist">
                                <div>
                                  <img src={localStorage.getItem("ProfilePhoto")} />
                                  {localStorage.getItem("UserName")}
                                </div>
                                {timeTrackClock
                                  ? `${timerTimeTrack - timerPrevTimeTrack}`.toHHMMSS()
                                  : `${timerTimeTrack}`.toHHMMSS()}
        
                                <FontAwesomeIcon
                                  className="cancel-icon"
                                  color="darkgray"
                                  icon={faMinus}
                                />
                              </div>
                              <UncontrolledCollapse toggler="timetracklist">
                                <div className="time_track_scroll">
                                  <table className="w-100 ">
                                    <tbody>
                                      {timeTrackLogs?.length > 0 && <TopPositionTimeTrack
                                        timeTrackClock={timeTrackClock}
                                        timerObj={timerObj}
                                        timeTrackLogs={timeTrackLogs}
                                        setTimerTimeTrack={setTimerTimeTrack}
                                        setTimerPrevTimeTrack={setTimerPrevTimeTrack}
                                        startstopClockTimeTrack={startstopClockTimeTrack}
                                        handleOnOpenTask={handleOnOpenTask}
                                        setDeleteTimeLogObj={setDeleteTimeLogObj}
                                        setTimeDeleteWarn={setTimeDeleteWarn}
                                        getTaskToolTipLabel={getTaskToolTipLabel}
                                      />}
                                    </tbody>
                                  </table>
                                </div>
                              </UncontrolledCollapse>
                              <div className="p-2 border-top">
                                <Tabs
                                  className="mb-2 time_tracked_tabs"
                                  id="controlled-tab-example"
                                  activeKey={timeTrackKey}
                                  onSelect={(k) => setTimeTrackKey(k)}
                                >
                                  <Tab eventKey="timer" title="Timer">
                                    <Row style={{ marginTop: "20px" }}>
                                      <Col sm={12}>
                                        {/* <AntdPopover placement="top" content={getContentForSearchTask()} trigger={'click'}> */}
                                        <div className="form-group form-group-sm">
                                          <TaskGlobalSearch
                                            onSelect={(task) => {
                                              setTimerObj({
                                                jobId: task.JobId,
                                                jobName: task.name,
                                                selectedTask: true,
                                              });
                                            }}
                                            nodeElement={
                                              <input
                                                value={
                                                  timerObj && timerObj.selectedTask
                                                    ? timerObj.jobName
                                                    : ""
                                                }
                                                style={{ cursor: "pointer" }}
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Search Task"
                                                name=""
                                              />
                                            }
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row style={{ marginTop: "20px" }}>
                                      <Col sm={6}>
                                        <div className="d-flex align-items-center">
                                          <FontAwesomeIcon
                                            className={
                                              timerObj && timeTrackClock
                                                ? "mr-2 timeTrackedIconPause"
                                                : "mr-2 timeTrackedIconPlay"
                                            }
                                            icon={
                                              timerObj && timeTrackClock
                                                ? faStopCircle
                                                : faPlayCircle
                                            }
                                            onClick={() => {
                                              if (timerObj && timerObj.jobId) {
                                                let filterTimeLog = timeTrackLogs.filter(
                                                  (one) => one.jobId == timerObj.jobId
                                                );
                                                if (filterTimeLog.length > 0) {
                                                  setTimerPrevTimeTrack(
                                                    filterTimeLog[0].totaltime
                                                  );
                                                  setTimerTimeTrack(
                                                    filterTimeLog[0].totaltime
                                                  );
                                                  startstopClockTimeTrack(timerObj);
                                                } else {
                                                  setTimerTimeTrack(0);
                                                  setTimerPrevTimeTrack(0);
                                                  startstopClockTimeTrack(timerObj);
                                                }
                                              } else {
                                                swal("Please select task", {
                                                  dangerMode: true,
                                                });
                                              }
                                            }}
                                          />
                                          <div>
                                            {timerObj && timeTrackClock
                                              ? `${timerTimeTrack}`.toHHMMSS()
                                              : `${timerTimeTrack}`.toHHMMSS()}
                                          </div>
                                        </div>
                                      </Col>
        
                                      <UncontrolledTooltip placement="top" target="running">
                                        {getTaskToolTipLabel(timerObj)}
                                      </UncontrolledTooltip>
                                      <Col
                                        id="running"
                                        onClick={() => handleOnOpenTask(timerObj)}
                                        style={{ color: "#40a9ff", cursor: "pointer" }}
                                        sm={6}
                                      >
                                        <span>
                                          {timeTrackClock && timerObj
                                            ? timerObj.jobName
                                            : ""}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Tab>
                                  <Tab eventKey="range" title="Range">
                                    <div className="form-group form-group-sm">
                                      <TaskGlobalSearch
                                        onSelect={(task) => {
                                          setTimerObj({
                                            jobId: task.JobId,
                                            jobName: task.name,
                                            selectedTask: true,
                                          });
                                        }}
                                        nodeElement={
                                          <input
                                            value={
                                              timerObj && timerObj.selectedTask
                                                ? timerObj.jobName
                                                : ""
                                            }
                                            style={{ cursor: "pointer" }}
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search Task"
                                            name=""
                                          />
                                        }
                                      />
                                    </div>
        
                                    <div className="time_tracked_fields mb-2">
                                      <input
                                        onChange={(e) => {
                                          setTimeLogDate(e.currentTarget.value);
                                        }}
                                        value={timeLogDate ? timeLogDate : ""}
                                        type="date"
                                        className="form-control form-control-sm"
                                      />
                                    </div>
                                    <div className="time_tracked_fields mb-2">
                                      <TimePicker
                                        format="hh:mm a"
                                        clearIcon={null}
                                        disableClock={true}
                                        onChange={(e) => {
                                          setFromRange(e);
                                        }}
                                        value={FromRange}
                                      />
                                      -
                                      <TimePicker
                                        format="hh:mm a"
                                        clearIcon={null}
                                        disableClock={true}
                                        onChange={(e) => {
                                          setToRange(e);
                                        }}
                                        value={ToRange}
                                      />
                                    </div>
                                    <Row>
                                      <Col sm={7}>
                                        <p style={{ marginLeft: "14px" }}>When: now</p>
                                      </Col>
                                      <Col sm={5}>
                                        <span className="float-right">
                                          <button
                                            className="btn btn-primary btn-small ml-2"
                                            onClick={() => {
                                              if (FromRange && ToRange && timeLogDate) {
                                                onSaveTimeRange(
                                                  FromRange,
                                                  ToRange,
                                                  timeLogDate
                                                );
                                              } else {
                                                swal("Please Set Valid Time", {
                                                  dangerMode: true,
                                                });
                                              }
                                            }}
                                          >
                                            Save
                                          </button>
                                        </span>
                                      </Col>
                                    </Row>
                                  </Tab>
                                </Tabs>
                              </div>
                            </div>
                          }
                        >
                          <div
                            id="time-track-icon"
                            style={{ background: "rgb(45, 204, 110)" }}
                            className="reminder-box"
                          >
                            <FontAwesomeIcon size="2x" icon={faStopwatch} />
                            {timerObj && timeTrackClock ? (
                              <span>
                                {timerObj && timeTrackClock
                                  ? `${timerTimeTrack}`.toHHMMSS()
                                  : ""}
                              </span>
                            ) : (
                              <></>
                            )} 
                            {timerObj && timeTrackClock ? (
                              <FontAwesomeIcon
                                onClick={() => startstopClockTimeTrack(timerObj)}
                                style={
                                  timerObj && timeTrackClock
                                    ? { color: "rgb(204, 45, 45)" }
                                    : { color: "rgb(45, 204, 110)" }
                                }
                                size="2x"
                                icon={faPauseCircle}
                              />
                            ) : (
                              <></>
                            )}
                          </div>
                        </AntdPopover> 
  </div>
    )
}
